import './overlay.less';

import $ from 'jquery';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import get from 'lodash/get';
import throttle from 'lodash/throttle';
import autobind from 'class-autobind';

import userAgentDetect from 'zoomforth_zfutils/useragent_detect.js';

import OverlayUi from './overlay.ui.jsx';

import { 
  getContentItemType,
  setTextLinksToDisplayExternalOpenMsg
} from 'zoomforth_codesbane_viewer/lib/page_content_utils.js';

import { getTracker } from 'zoomforth_codesbane_viewer/lib/global_store.js';

class Overlay extends Component {
  // when using this, a key should be set on the item UUID, 
  // so we can safely put all of the content loading logic into componentDidMount
  
  constructor(props) {
    super(props);
    
    this.baseNodeRef = null;

    const itemType = getContentItemType(this.props.contentItem);
    
    this.state = {
      loading: true,
      pptIsLoading: itemType === 'ppt' && !this.shouldRenderAsMobile()
    };

    autobind(this);
  }
  

  componentDidMount() {
    this.recalculateCaptionPosition();
    this.setUpSidebarDescriptionLinks(this.baseNodeRef);
    this.props.onOverlayDisplay();
    
    // TODO in editor: this should probably NOT be bound in the editing context
    $(document).bind('keyup.overlay', this.handleKeyPress);   

    $('body').addClass('overlay-open');

    getTracker().handleOverlayDisplayed(this.props.contentItem.uuid);
    
    $(window).on('resize.zoomforth-overlay', throttle(()=> {
      this.recalculateCaptionPosition();
    }, 50));

    setTextLinksToDisplayExternalOpenMsg(this.baseNodeRef, '.overlay-caption-content a');
  }
  
  componentDidUpdate() {
    this.setUpSidebarDescriptionLinks(this.baseNodeRef);
    this.recalculateCaptionPosition();
  }

  componentWillUnmount() {
    $(window).off('resize.zoomforth-overlay');
    $(document).unbind('keyup.overlay');   

    $('body').removeClass('bottom-captions');
    $('body').removeClass('overlay-open');

  }
  
  setUpSidebarDescriptionLinks(baseNode) {
    $(baseNode).find('.overlay-caption-content').find('a').attr('target', '_blank');
  }

  recalculateCaptionPosition() {
    if (($(window).height() * 0.95) > $(window).width()){
      $('body').addClass('bottom-captions');
    } else{
      $('body').removeClass('bottom-captions');
    }    
  }
  
  
  handleKeyPress(e) {
    if (e.keyCode == 27) { // esc key
      this.props.onRequestClose(); 
    }
  }

  
  shouldRenderAsMobile() {
    return this.props.renderAsMobile || userAgentDetect.isMobile.isAnyRealDevice();
  }
  

  render() {
    const {
      asset,
      contentItem,
      videoishPlayerProps,
      cssClassesListForOverlay,
      onRequestClose,
      onPresentationSlideDisplay,
      onPresentationDownloadClick,
      slideshowData,
      isPreviewCollaborationEnabled
    } = this.props;

    const {
      pptIsLoading,
      loading
    } = this.state;

    const itemType = getContentItemType(contentItem);
    const renderAsMobile = this.shouldRenderAsMobile();
    
    if (itemType === 'text') {
      throw new Error(
        'Cannot show overlay for text: state has been set incorrectly and it is probably the router\'s fault somehow'
      );
    }
    
    const sidebarTitle = contentItem.title || '';
    const sidebarDescription = contentItem.renderedCaption;
    
    const hasSidebar = (
      itemType != 'pdf' &&
      itemType != 'ppt' &&
      (sidebarDescription || sidebarTitle)
    );
    return (
      <OverlayUi
        className={classNames('overlay', `type-${itemType}`, cssClassesListForOverlay, {'no-caption': !hasSidebar})}
        tellRef={(ref)=>{
          this.baseNodeRef=ref;
        }}
        altText={contentItem.alt_text || get(asset, 'alt_text', '')}
        loading={loading}
        sidebarTitle={sidebarTitle}
        sidebarDescription={sidebarDescription}
        slides={asset && asset.slides}
        displayFilename={asset && asset.display_filename}
        htmlPackageEntrypointUrl={asset && asset.entrypointUrl}
        downloadLink={asset && asset.downloadLink}
        canDownloadAsset={contentItem.can_download_asset}
        assetLink={asset && asset.link}
        iframeEmbedUrl={contentItem.iframe_embed_url}
        iframeTitle={contentItem.iframe_title || 'Embedded Content'}
        assetDisplayImage={asset && asset.displayImage}
        assetDownloadLink={asset && asset.downloadLink}
        assetExtension={asset && asset.extension}
        itemType={itemType}
        pptIsLoading={pptIsLoading}
        shouldRenderAsMobile={renderAsMobile}
        renderedTileCaption={contentItem.renderedTileCaption}
        videoishPlayerProps={videoishPlayerProps}
        onLoadingChange={({ loading, pptIsLoading })=> {
          this.setState({
            loading,
            pptIsLoading
          });
        }}
        onPresentationSlideDisplay={onPresentationSlideDisplay}
        onPresentationDownloadClick={onPresentationDownloadClick}
        onRequestClose={onRequestClose}
        slideshowData={slideshowData}
        isPreviewCollaborationEnabled={isPreviewCollaborationEnabled}
      />
    );
  }

}



Overlay.propTypes = {
  contentItem: PropTypes.any.isRequired,
  onRequestClose: PropTypes.func,
  onOverlayDisplay: PropTypes.func.isRequired,
  renderAsMobile: PropTypes.bool
};

export default Overlay;
